import {legacyIncome} from "../lender-tests/useXlsTests";
import {expandArrayResult} from "./FiguresUsed";
import {
	ApplicationTypes, AssetTypes, BoolLike, BuildType, DebtTypes, EmploymentTypes, Frequencies, MortgageTypes, PersonalAccommodationSituations
} from "../../../../../../models";
import {lastYear1, lastYear2, lastYear3} from "../../../../../../assets/scripts/verifiedFigures";
import dayjs from "dayjs";
export const getJobPayDetails = (mortgage, applicantN, job) => {
	let verifiedSectionPayslips = mortgage.mortgageUploads.setup.find(s => s.name === `payslips-${applicantN}` && (!job.id || s.index === job.id))
	if (!verifiedSectionPayslips){
		return {frequency: null,
			averagePayslipBasic: null,
			mostRecentPayslip: null
		}
	}
	let payslips = []
	if (verifiedSectionPayslips && verifiedSectionPayslips.verified) {
		let verifiedPayslipsUploads = verifiedSectionPayslips.verified.uploads.active
		verifiedPayslipsUploads.forEach(verifiedUpload => {
			let values = verifiedUpload.verified.values;
			payslips.push({
				date : values.documentDate,
				gross: values.grossPay || 0,
				basic: values.grossBasic || 0,
				net  : values.netPay || 0,
			})
		})
	}
	if (!payslips.length) {
		return {
			error: 'No payslips found',
			value: 0
		}
	}
	let averagePayslipBasic = payslips.reduce((acc, payslip) => acc + payslip.basic, 0) / payslips.length
	let mostRecentPayslip = (payslips.reduce((a, b) => a.date > b.date ? a : b, {date: null})).basic

	return {
		frequency: job.payFrequency,
		averagePayslipBasic,
		mostRecentPayslip
	}
}
class applicantVerifiedFigures {
	constructor(mortgage, appN) {
		this.mortgage = mortgage
		this.legacy = legacyIncome(mortgage)
		this.n = appN
		this.applicant = mortgage[`applicant${appN}`]
		this.applicantIsEmployed = this.isEmployed()
	}
	isEmployed = () => {
		if (this.legacy) {
			return [
				EmploymentTypes.EMPLOYED,
				EmploymentTypes.SELFEMPLOYED
			].includes(this.applicant.employment.employmentType)
		}
		return !!this.applicant.employmentIncome.find(it => [
			EmploymentTypes.EMPLOYED,
			EmploymentTypes.SELFEMPLOYED
		].includes(it.employmentType))
	}
	getVerifiedSalaryCertValue = (job) => {
		let verifiedSectionSalaryCertificate = this.mortgage.mortgageUploads.apply.find(s => s.name === `salary-cert-${this.n}` && ((!job.id && !s.index) || (s.index === job.id)))
		let certs = []
		if (verifiedSectionSalaryCertificate) {
			let verifiedSalaryCertificateUploads = verifiedSectionSalaryCertificate.verified.uploads.active
			verifiedSalaryCertificateUploads.forEach(verifiedUpload => {
				let values = verifiedUpload.verified.values;
				certs.push({
					date : values.documentDate,
					basic: values.grossBasic || 0,
				})
			})
		}
		if (!certs.length) {
			return {
				error: 'No salary cert found',
				value: 0
			}
		}
		// get the most recent cert
		let mostRecentCert = certs.reduce((a, b) => a.date > b.date ? a : b, {date: null})
		return {
			value: mostRecentCert.basic
		}
	}
	getVerifiedPayslipValue = (job) => {
		let verifiedSectionPayslips = this.mortgage.mortgageUploads.setup.find(s => s.name === `payslips-${this.n}` && (!job.id || s.index === job.id))
		let payslips = []
		if (verifiedSectionPayslips && verifiedSectionPayslips.verified) {
			let verifiedPayslipsUploads = verifiedSectionPayslips.verified.uploads.active

			verifiedPayslipsUploads.forEach(verifiedUpload => {
				let values = verifiedUpload.verified.values;
				payslips.push({
					date : values.documentDate,
					gross: values.grossPay || 0,
					basic: values.grossBasic || 0,
					net  : values.netPay || 0,
				})
			})
		}
		if (!payslips.length) {
			return {
				error: 'No payslips found',
				value: 0
			}
		}
		let averagePayslipBasic = payslips.reduce((acc, payslip) => acc + payslip.basic, 0) / payslips.length
		let mostRecentPayslip = payslips.reduce((a, b) => a.date > b.date ? a : b, {date: null})
		return {
			value: averagePayslipBasic
			// value: mostRecentPayslip.basic
		}

	}
	fields = {
		basic: () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			const returnBasic = (job) => {
				let verifiedPayslipValue = this.getVerifiedPayslipValue(job)
				if (verifiedPayslipValue.error) {
					return {
						error: 'No payslip found',
						value: 0
					}
				}
				let amt = 0

				switch (job.payFrequency) {
					case Frequencies.WEEKLY:
						amt = verifiedPayslipValue.value * (365 / 7)
						break;
					case Frequencies.MONTHLY:
						amt = verifiedPayslipValue.value * 12
						break;
					case Frequencies.FORTNIGHTLY:
						amt = verifiedPayslipValue.value * (job.publicSector ? 26.09 : 26)
						break;
					default:
						return {
							error: 'Pay frequency not set',
							value: 0
						}
				}
				// round amt to 0 decimal places
				amt = Math.round(amt)
				return {
					value  : amt
				}
				// let verifiedSalaryCertValue = this.getVerifiedSalaryCertValue(job);


				//if (verifiedSalaryCertValue.error) {

				//}
				//return {
				//	value: verifiedSalaryCertValue.value
			//	}
			}

			if (this.legacy) {
				return returnBasic({
					...this.applicant.employment,
					payFrequency: this.applicant.income.payFrequency,
					id: null
				})
			}
			return expandArrayResult('add', this.applicant.employmentIncome.map(job => {
				return returnBasic(job)
			}))
		}

	}
}

class applicantApplicationFigures {
	constructor(mortgage, appN) {
		this.mortgage = mortgage
		this.legacy = legacyIncome(mortgage)
		this.n = appN
		this.applicant = mortgage[`applicant${appN}`]
		this.applicantIsEmployed = this.isEmployed()
	}
	bonusMaker = (year) => {
		return () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			if (this.legacy) {
				if ((this.applicant.income.incomeChecks || []).includes('BONUS')) {
					if (!this.applicant.income.bonus) {
						return {
							error: 'No bonus'
						}
					}
					return {value: this.applicant.income.bonus}
				}
				return {
					value: 0
				}
			}
			return expandArrayResult('add', this.applicant.employmentIncome.map(it => {
				let item =  it.incomes ? it.incomes.filter(it=>!!it).find(income => income.name === 'bonus' && income.guaranteed) : null
				let value = item?.yearMostRecent || item?.amount || 0
				return {
					value
				}
			}))
		}
	}
	isEmployed = () => {
		if (this.legacy) {
			return [
				EmploymentTypes.EMPLOYED,
				EmploymentTypes.SELFEMPLOYED
			].includes(this.applicant.employment.employmentType)
		}
		return !!this.applicant.employmentIncome.find(it => [
			EmploymentTypes.EMPLOYED,
			EmploymentTypes.SELFEMPLOYED
		].includes(it.employmentType))
	}
	fields = {
		sector            : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			if (this.legacy) {
				if (!this.applicant.employment.employmentType) {
					return {
						error: 'No employment type'
					}
				}
				return {value: this.applicant.employment.employmentType === EmploymentTypes.SELFEMPLOYED ? 'self' : 'private'}
			}
			let emp
			if (this.applicant.employmentIncome.length > 1) {
				if (!this.applicant.employment.primaryEmploymentId) {
					return {
						error: 'Primary employment not selected',
						value: ''
					}
				}
				emp = this.applicant.employmentIncome.find(it => it.id === this.applicant.employment.primaryEmploymentId)
			}
			else {
				emp = this.applicant.employmentIncome[0]
			}
			return {
				value: emp.employmentType === EmploymentTypes.SELFEMPLOYED ? 'self' : emp.publicSector ? 'public' : 'private'
			}
		},
		basic             : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			if (this.legacy) {
				if (!this.applicant.income.grossBasic) {
					return {
						error: 'No gross basic',
						value: 0
					}
				}
				return {value: this.applicant.income.grossBasic}
			}
			return expandArrayResult('add', this.applicant.employmentIncome.map(it => {
				if (!it.grossBasic) {
					return {
						error: 'No gross basic',
						value: 0
					}
				}
				return {
					value: it.grossBasic
				}
			}))
		},
		overtime          : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}

			if (this.legacy) {
				if ((this.applicant.income.incomeChecks || []).includes('OVERTIME')) {
					if (!this.applicant.income.overtime) {
						return {
							error: 'No overtime',
							value: 0
						}
					}
					return {value: this.applicant.income.overtime}
				}
				return {
					value: 0
				}
			}
			return expandArrayResult('add', this.applicant.employmentIncome.map(it => {

				let item =  it.incomes ? it.incomes.filter(it=>!!it).find(income => income.name === 'overtime' && income.guaranteed) : null
				let value = item?.yearMostRecent || item?.amount || 0
				return {
					value
				}
			}))
		},
		allowances        : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			if (this.legacy) {
				if ((this.applicant.income.incomeChecks || []).includes('ALLOWANCES')) {
					if (!this.applicant.income.allowances) {
						return {
							error: 'No allowances'
						}
					}
					return {value: this.applicant.income.allowances}
				}
				return {
					value: 0
				}
			}
			return expandArrayResult('add', this.applicant.employmentIncome.map(it => {
				let item =  it.incomes ? it.incomes.filter(it=>!!it).find(income => income.name === 'shiftAllowance' && income.guaranteed) : null
				let value = item?.yearMostRecent || item?.amount || 0
				return {
					value
				}
			}))

		},
		other             : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			if (this.legacy) {
				if ((this.applicant.income.incomeChecks || []).includes('OTHER')) {
					if (!this.applicant.income.other) {
						return {
							error: 'No other'
						}
					}
					return {value: this.applicant.income.other}
				}
				return {
					value: 0
				}
			}
			return expandArrayResult('add', this.applicant.employmentIncome.map(it => {
				let item =  it.incomes ? it.incomes.filter(it=>!!it).find(income => income.name === 'otherAllowance' && income.guaranteed) : null
				let value = item?.yearMostRecent || item?.amount || 0
				return {
					value
				}
			}))

		},
		commission        : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			if (this.legacy) {
				if ((this.applicant.income.incomeChecks || []).includes('COMMISSION')) {
					if (!this.applicant.income.commission) {
						return {
							error: 'No commission'
						}
					}
					return {value: this.applicant.income.commission}
				}
				return {
					value: 0
				}
			}
			return expandArrayResult('add', this.applicant.employmentIncome.map(it => {
				let item =  it.incomes ? it.incomes.filter(it=>!!it).find(income => income.name === 'commission' && income.guaranteed) : null
				let value = item?.yearMostRecent || item?.amount || 0
				return {
					value
				}
			}))

		},
		year1Bonus        : this.bonusMaker(lastYear1),
		year2Bonus        : this.bonusMaker(lastYear2),
		year3Bonus        : this.bonusMaker(lastYear3),
		clearingLoans     : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			let loans = this.applicant.debts.filter(debt => debt.debtType === DebtTypes.LOAN && !!debt.clearedBeforeMortgage)
			return expandArrayResult('add', loans.map(debt => {
				if (!debt.monthlyPayment) {
					return {error: 'Missing monthly payment'}
				}
				return {value: debt.monthlyPayment}
			}))
		},
		pension           : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			return {
				message: 'We dont collect this',
				value  : 0
			}
		},
		accommodationCosts: () => {
			// if (!this.applicant.personal.accommodationSituation) {
			// 	return {
			// 		error: 'No accommodation situation',
			// 		value: 0
			// 	}
			// }
			if (!this.applicant.financial.monthlyAccommodationCosts) {
				return {
					error: 'No monthly accommodation costs',
					value: 0
				}
			}
			let error = null
			let rent = 0
			//if (this.applicant.personal.accommodationSituation === PersonalAccommodationSituations.RENTED) {
				rent += this.applicant.financial.monthlyAccommodationCosts ||0
			//}
			//else if (this.applicant.personal.accommodationSituation === PersonalAccommodationSituations.RELATIVES && this.applicant.financial.contributeToRelatives) {
				//rent += this.applicant.financial.monthlyAccommodationCosts
			//	error = 'Includes boarding cost!!'
			//}
			//else if (this.mortgage.mortgageType === MortgageTypes.REFINANCE || this.mortgage.applicationType === ApplicationTypes.MOVINGHOME) {
			//	rent += this.applicant.financial.monthlyAccommodationCosts
		//	}
			if (error){
				return {
					value: rent,
					error
				}
			}
			return {value: rent}
		},
		otherPRA          : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicantIsEmployed) {
				return {
					message: 'Not employed',
					value  : 0
				}
			}
			return {
				value  : 0,
				message: 'Not collected'
			}
		},
		credit            : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			let credit = this.applicant.debts.filter(debt => [
				DebtTypes.CREDITCARD,
				DebtTypes.STORECARD
			].includes(debt.debtType))
			return expandArrayResult('add', credit.map(debt => {
				if (!debt.creditLimit) {
					return {value:0,error: 'Missing credit limit'}
				}
				return {value: debt.creditLimit}
			}))
		},
		maintenancePaid   : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (this.applicant.financial.paysMaintenance) {
				if (!this.applicant.financial.maintenanceCosts) {
					return {
						error: 'Mission maintenance costs',
						value: 0
					}
				}
				return {value: this.applicant.financial.maintenanceCosts}
			}
			return {value: 0}
		},
		loans             : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			let loans = this.applicant.debts.filter(debt => debt.debtType === DebtTypes.LOAN && !debt.clearedBeforeMortgage)
			return expandArrayResult('add', loans.map(debt => {
				if (!debt.monthlyPayment) {
					return {error: 'Missing monthly payment'}
				}
				return {value: debt.monthlyPayment}
			}))
		},
		childmindingCosts : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (!this.applicant.financial.hasChildcareCosts) {
				return {
					value: 0
				}
			}
			if (this.applicant.financial.hasChildcareCosts && !this.applicant.financial.monthlyChildcareCosts) {
				return {
					error: 'Missing childcare costs',
					value: 0
				}
			}
			return {
				value: this.applicant.financial.monthlyChildcareCosts
			}
		},
		funds             : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			if (this.n === 2) {
				return {
					value  : 0,
					message: 'We dont collect separately'
				}
			}
			if (!this.mortgage.requirement.depositSavings) {
				return {
					warning: 'No deposit supplied',
					value  : 0
				}
			}
			return {
				value: this.mortgage.requirement.depositSavings
			}
		},
		savings           : () => {
			if (this.n === 2 && !this.mortgage.twoApplicants) {
				return {
					message: 'No applicant 2',
					value  : 0
				}
			}
			let savings = []
			let filter = asset => {
				if (asset.assetType === AssetTypes.SAVING) {
					if ([
						Frequencies.MONTHLY,
						Frequencies.WEEKLY,
						Frequencies.FORTNIGHTLY
					].includes(asset.increasesFrequency))
					{
						return true
					}
				}
				return false
			}
			if (this.applicant.financial.monthlySavings && (this.applicant.financial.hasCurrentAccountSavings || this.applicant.financial.hasSavings)) {


				savings.push({
					value: this.applicant.financial.monthlySavings
				})

			}
			else{

				let allSavings = this.applicant.assets.filter(filter)
				if (allSavings.length) {
					savings.push(...allSavings.map(asset => {
						if (!asset.increasesFrequency) {
							return {
								error: 'Missing saving frequency',
								value: 0
							}
						}
						if (!asset.increases) {
							return {
								error: 'Missing saving amount',
								value: 0
							}
						}

						switch (asset.increasesFrequency) {
							case Frequencies.MONTHLY:
								return {
									value: asset.increases
								}
							case Frequencies.FORTNIGHTLY:
								return {
									value: Number((asset.increases * 26 / 12).toFixed(2))
								}
							default:
								return {
									value: Number((asset.increases * 52 / 12).toFixed(2))
								}
						}
					}))
				}
			}

			return expandArrayResult('add', savings)
		}
	}
}

class mortgageApplicationFigures {
	constructor(mortgage) {
		this.mortgage = mortgage
	}
	fields = {
		helpToBuy: () => {
			if (this.mortgage.properties[0]?.propertyValue > 500000) {
				return {
					value  : 0,
					message: 'Property > €500k'
				}
			}
			if (this.mortgage.properties[0]?.buildType !== BuildType.NEW) {
				return {
					value  : 0,
					message: 'Not new build'
				}
			}
			if (this.mortgage.requirement.helpToBuyScheme !== BoolLike.FALSE) {
				let response = {
					value: this.mortgage.requirement.helpToBuySchemeAmount || this.mortgage.twoApplicants ? 30000 : 25000
				}
				if (this.mortgage.requirement.helpToBuyScheme === BoolLike.NOTSURE) {
					response.warning = 'Not sure about help to buy'
				}
				return response
			}
			return {
				value  : 0,
				message: 'Not utilised'
			}
		},
		firstHome: () => {
			if (this.mortgage.requirement.firstHomeScheme !== BoolLike.FALSE) {
				let response = {
					value: this.mortgage.requirement.firstHomeSchemeAmount || 0
				}
				if (response.value === 0) {
					response.warning = 'No first home amount'
				}
				if (this.mortgage.requirement.firstHomeScheme === BoolLike.NOTSURE) {
					response.warning = 'Not sure about first home'
				}
				return response
			}
			return {
				value  : 0,
				message: 'Not utilised'
			}
		},
		gift     : () => {
			if (![
				true,
				false
			].includes(this.mortgage.requirement.receivingGifts))
			{
				return {
					value: 0,
					error: 'If gifts not answered'
				}
			}
			if (this.mortgage.requirement.receivingGifts) {
				return {
					value: this.mortgage.requirement.depositGifts || 0
				}
			}
			return {
				value  : 0,
				message: 'Not utilised'
			}
		}
	}
}

function getRoundedAge(dob) {
	const birthDate = dayjs(dob, 'YYYY-MM-DD');
	const today = dayjs();
	const exactAge = today.diff(birthDate, 'year', true); // Get age as a decimal
	return Math.round(exactAge); // Round to nearest whole number
}

export const figuresForCalcs = (mortgage, useVerifiedFigures = false) => {
	let numberInHousehold = 1
	let numberOfDependentChildren = 0
	let numberOfAdultsBoarding = 0
	let dependents = []
	if (mortgage.applicant1.personal.countDependents > 0) {
		let count1 = mortgage.applicant1.personal.dependentDOBs?.length || 0
		numberOfDependentChildren += count1
		if (count1 > 0) {
			mortgage.applicant1.personal.dependentDOBs.forEach(dob => dependents.push({age: getRoundedAge(dob)}))
		}

	}
	if (mortgage.twoApplicants) {
		numberInHousehold++
		let count2 = mortgage.applicant2.personal.dependentDOBs?.length || 0
		numberOfDependentChildren += count2
		if (count2 > 0) {
			mortgage.applicant2.personal.dependentDOBs.forEach(dob => dependents.push({age: getRoundedAge(dob)}))
		}

	}
	if (mortgage.requirement.adultsBoarding) {
		numberOfAdultsBoarding += mortgage.requirement.adultsBoardingCount
	}
	numberInHousehold += numberOfDependentChildren + numberOfAdultsBoarding
	// Deposit is only asked for moving home with PTSB
	const deposit = mortgage.applicationType === ApplicationTypes.MOVINGHOME ? mortgage.requirement.depositSavings : 0
	const applicantData = (applicantNumber) => {
		const legacy = legacyIncome(mortgage)
		const applicant = mortgage[`applicant${applicantNumber}`]
		const isEmployed = () => {
			if (legacy) {
				return [
					EmploymentTypes.EMPLOYED,
					EmploymentTypes.SELFEMPLOYED
				].includes(applicant.employment.employmentType)
			}
			return !!applicant.employmentIncome.find(it => [
				EmploymentTypes.EMPLOYED,
				EmploymentTypes.SELFEMPLOYED
			].includes(it.employmentType))
		}
		const jobs = () => {
			if (legacy) {
				return [
					{
						sector                   : applicant.employment.employmentType === EmploymentTypes.SELFEMPLOYED ? 'SELF' : 'PRIVATE',
						lastP60                  : 0, //TODO
						yearlyAVCContribution    : 0, //TODO
						yearlyPensionContribution: 0, //TODO
						nextPayScale             : 0, //TODO
						nextPayScaleAfter        : 0, //TODO
						basic                    : {
							yearMostRecent: applicant.income.grossBasic,
							yearBefore    : 0,
							yearBeforeThat: 0,
							guaranteed    : true,
						},
						shiftAllowance           : {
							yearMostRecent: (applicant.employment.incomeChecks || []).includes('ALLOWANCES') ? applicant.income.allowances : 0,
							yearBefore    : 0,
							yearBeforeThat: 0,
							guaranteed    : true,
						},
						carAllowance             : {
							yearMostRecent: 0,
							yearBefore    : 0,
							yearBeforeThat: 0,
							guaranteed    : false,
						},
						otherAllowance           : { // other allowances
							yearMostRecent: (applicant.employment.incomeChecks || []).includes('OTHER') ? applicant.income.other : 0,
							yearBefore    : 0,
							yearBeforeThat: 0,
							guaranteed    : true,
						},
						overtime                 : {
							yearMostRecent: (applicant.employment.incomeChecks || []).includes('OVERTIME') ? applicant.income.overtime : 0,
							yearBefore    : 0,
							yearBeforeThat: 0,
							guaranteed    : true,
						},
						bonus                    : {
							yearMostRecent: (applicant.employment.incomeChecks || []).includes('BONUS') ? applicant.income.bonus : 0,
							yearBefore    : 0,
							yearBeforeThat: 0,
							guaranteed    : true,
						},
						commission               : {
							yearMostRecent: (applicant.employment.incomeChecks || []).includes('COMMISSION') ? applicant.income.commission : 0,
							yearBefore    : 0,
							yearBeforeThat: 0,
							guaranteed    : false,
						},
					}
				]
			}
			return applicant.employmentIncome.map(emp => {
				const modernBasic = (emp.incomes||[]).find(income => income.name === 'basic')
				const shiftAllowance = (emp.incomes||[]).find(income => income.name === 'shiftAllowance')
				const carAllowance = (emp.incomes||[]).find(income => income.name === 'carAllowance')
				const otherAllowance = (emp.incomes||[]).find(income => income.name === 'otherAllowance')
				const overtime = (emp.incomes||[]).find(income => income.name === 'overtime')
				const commission = (emp.incomes||[]).find(income => income.name === 'commission')
				const bonus = (emp.incomes||[]).find(income => income.name === 'bonus')
				return {
					sector                   : emp.employmentType === EmploymentTypes.SELFEMPLOYED ? 'SELF' : emp.publicSector ? 'PUBLIC' : 'PRIVATE',
					lastP60                  : 0, //TODO
					yearlyAVCContribution    : 0, //TODO
					yearlyPensionContribution: 0, //TODO
					basic                    : {
						yearMostRecent: !!modernBasic ? modernBasic.yearMostRecent : emp.grossBasic,
						yearBefore    : !!modernBasic ? modernBasic.yearBefore : 0,
						yearBeforeThat: !!modernBasic ? modernBasic.yearBeforeThat : 0,
						guaranteed    : true,
					},
					shiftAllowance           : {
						yearMostRecent: !!shiftAllowance ? shiftAllowance.yearMostRecent || shiftAllowance.amount || 0 : 0,
						yearBefore    : !!shiftAllowance ? shiftAllowance.yearBefore || 0 : 0,
						yearBeforeThat: !!shiftAllowance ? shiftAllowance.yearBeforeThat || 0 : 0,
						guaranteed    : !!shiftAllowance ? shiftAllowance.guaranteed || false : false,
					},
					carAllowance             : {
						yearMostRecent: !!carAllowance ? carAllowance.yearMostRecent || carAllowance.amount || 0 : 0,
						yearBefore    : !!carAllowance ? carAllowance.yearBefore || 0 : 0,
						yearBeforeThat: !!carAllowance ? carAllowance.yearBeforeThat || 0 : 0,
						guaranteed    : !!carAllowance ? carAllowance.guaranteed || false : false,
					},
					otherAllowance           : {
						yearMostRecent: !!otherAllowance ? otherAllowance.yearMostRecent || otherAllowance.amount || 0 : 0,
						yearBefore    : !!otherAllowance ? otherAllowance.yearBefore || 0 : 0,
						yearBeforeThat: !!otherAllowance ? otherAllowance.yearBeforeThat || 0 : 0,
						guaranteed    : !!otherAllowance ? otherAllowance.guaranteed || false : false,
					},
					overtime                 : {
						yearMostRecent: !!overtime ? overtime.yearMostRecent || overtime.amount || 0 : 0,
						yearBefore    : !!overtime ? overtime.yearBefore || 0 : 0,
						yearBeforeThat: !!overtime ? overtime.yearBeforeThat || 0 : 0,
						guaranteed    : !!overtime ? overtime.guaranteed || false : false,
					},
					bonus                    : {
						yearMostRecent: !!bonus ? bonus.yearMostRecent || bonus.amount || 0 : 0,
						yearBefore    : !!bonus ? bonus.yearBefore || 0 : 0,
						yearBeforeThat: !!bonus ? bonus.yearBeforeThat || 0 : 0,
						guaranteed    : !!bonus ? bonus.guaranteed || false : false,
					},
					commission               : {
						yearMostRecent: !!commission ? commission.yearMostRecent || commission.amount || 0 : 0,
						yearBefore    : !!commission ? commission.yearBefore || 0 : 0,
						yearBeforeThat: !!commission ? commission.yearBeforeThat || 0 : 0,
						guaranteed    : !!commission ? commission.guaranteed || false : false,
					},
				}
			})
		}
		const savings = () => {
			let savings = []
			if (applicant.financial.hasCurrentAccountSavings) {
				if (applicant.financial.monthlySavings) {
					savings.push(applicant.financial.monthlySavings)
				}
			}
			let filter = asset => {
				if (asset.assetType === AssetTypes.SAVING) {
					if ([
						Frequencies.MONTHLY,
						Frequencies.WEEKLY,
						Frequencies.FORTNIGHTLY
					].includes(asset.increasesFrequency))
					{
						return true
					}
				}
				return false
			}
			let allSavings = applicant.assets.filter(filter)
			if (allSavings.length) {
				savings.push(...allSavings.map(asset => {
					if (!asset.increasesFrequency) {
						return 0
					}
					if (!asset.increases) {
						return 0
					}
					switch (asset.increasesFrequency) {
						case Frequencies.MONTHLY:
							return asset.increases
						case Frequencies.FORTNIGHTLY:
							return asset.increases * 26 / 12
						case Frequencies.WEEKLY:
							return asset.increases * 52 / 12
						default:
							return 0
					}
				}))
			}
			return savings.reduce((acc, cur) => acc + cur, 0)
		}
		const clearingLoans = () => {
			let loans = applicant.debts.filter(debt => debt.debtType === DebtTypes.LOAN && !!debt.clearedBeforeMortgage)
			return loans.reduce((acc, cur) => acc + cur.monthlyPayment || 0, 0)
		}
		const loans = () => {
			let loans = applicant.debts.filter(debt => debt.debtType === DebtTypes.LOAN && !debt.clearedBeforeMortgage)
			return loans.reduce((acc, cur) => acc + cur.monthlyPayment || 0, 0)
		}
		const credit = () => {
			let credit = applicant.debts.filter(debt => [
				DebtTypes.CREDITCARD,
				DebtTypes.STORECARD
			].includes(debt.debtType))
			return credit.reduce((acc, cur) => acc + cur.creditLimit || 0, 0)
		}
		const overdraft = () => {
			let overdraft = applicant.accounts.filter(acc => !!acc.hasOverdraft)
			return overdraft.reduce((acc, cur) => acc + cur.overdraftLimit || 0, 0)
		}
		return {
			works               : isEmployed(),
			maritalStatus       : applicant.personal.maritalStatus,
			age                 : getRoundedAge(applicant.personal.dateOfBirth), // age to be calculated elsewhere
			jobs                : jobs(),
			pra                 : {
				accommodation: applicant.financial.monthlyAccommodationCosts || 0,
				boarding     : applicant.personal.accommodationSituation === PersonalAccommodationSituations.RELATIVES,
				savings      : savings(),
				clearingLoans: clearingLoans(),
				other        : 0,
			},
			monthlyOutgoings    : {
				loans      : loans(),
				maintenance: applicant.financial.paysMaintenance ? applicant.financial.maintenanceCosts || 0 : 0,
				childcare  : applicant.financial.hasChildcareCosts ? applicant.financial.monthlyChildcareCosts || 0 : 0,
			},
			creditFacilityLimits: {
				creditCards: credit(),
				overdrafts : overdraft()
			},
			portfolio           : applicant.properties.map(prop => {
				return {
					isMortgaged                  : prop.isMortgaged,
					outstandingMortgage          : prop.outstanding,
					rate                         : prop.rate,
					rateFixedYears               : prop.rateFixedYears,
					tracker                      : false,
					interestOnly                 : prop.interestOnly,
					remainingTermInMonths        : prop.remainingTermInMonths,
					yearlyRentalIncome           : prop.rentPerAnnum,
					propertyValue                : prop.estimatedValue,
					foreign                      : prop.foreign,
					nonStandard                  : false,
					numberOfBedrooms             : prop.bedrooms,
					annualStressedMortgagePayment: prop.monthlyRepayments * 12,// can this not be moved to the lender?
				}
			}),
		}
	}

	const newData = {
		//add these after the fact:
		//loanRequired: mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.termRequired,
		// termRequired: mortgage.activeSubmission?.finalTerm || mortgage.activeSubmission?.provisionalTerm || mortgage.requirement.termRequired,
		//propertyValue: mortgage.property.propertyValue,

		fixedRateYears    : 3,
		selfBuild         : false, //this changes lower down
		applicationType   : mortgage.applicationType, //'MOVINGHOME',
		twoApplicants     : mortgage.twoApplicants,
		mortgageType      : mortgage.mortgageType,
		propertyType      : mortgage.property.propertyType,
		berScore          : mortgage.property.berScore,
		propertyIdentified: mortgage.property?.addressKnown,
		oneBedProperty    : mortgage.property.bedrooms === 1,
		numberInHousehold,
		numberOfAdultsBoarding,
		numberOfDependentChildren,
		dependents, //TODO : convert to age somwhere else
		applicant1        : applicantData(1),
	}
	if (mortgage.twoApplicants) {
		newData.applicant2 = applicantData(2)
	}
	if (mortgage.property.buildType === BuildType.SELFBUILD) {
		newData.selfBuild = {
			costToBuild: mortgage.property.constructionCosts,    // TODO: add to the front end application
			siteValue  : mortgage.property.siteValue,
		}
	}
	if (mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.applicationType === ApplicationTypes.MOVINGHOME) {   // TODO: add existing back into the mix
		newData.deposit = mortgage.requirement.depositSavings
		newData.existing = { // Movers
			//nonTrackerMortgageAmount: 0, // Tracker is a thing of the past!!
			//trackerMortgageAmount   : 0,// Tracker is a thing of the past!!
			//tracker                 : false,// TODO
			propertyValue        : mortgage.existing?.propertyValue||0,
			outstandingMortgage  : mortgage.existing?.outstanding||0,
			remainingTermInMonths: mortgage.existing?.remainingTermInMonths||0, // TODO: change to months to the front end application
			retaining            : mortgage.existing?.retaining||false,
			rate                 : mortgage.existing?.currentRate||0,
			rateFixedYears       : mortgage.existing?.rateFixedYears||0,
			numberOfBedrooms     : mortgage.existing?.numberOfBedrooms||0,
		}
	}
	return newData
}

export function useMortgageFigures(mortgage, viewingVerified) {

	const accumulator = {};

	const addFieldsToAccumulator = (fields, suffix = '') => {
		Object.keys(fields).forEach(key => {
			accumulator[`${key}${suffix}`] = fields[key]();
		});
	};

	const addVerifiedFundsToAccumulator = (applicantNumber) => {
		const allStatements = mortgage[`applicant${applicantNumber}`].verifiedAccounts;
		if (allStatements && allStatements.hasOwnProperty('€')) {
			const statements = allStatements['€']

			accumulator[`savings${applicantNumber}`] = expandArrayResult('add', statements.dataSource.filter(it => !it.excluded).map(it => {
				if (it.error) {
					return {
						error: it.error,
						value: 0
					};
				}
				return {value: it.averageMonthly};
			}));
			accumulator[`funds${applicantNumber}`] = {value: statements.totalClosingBalance}
		}
	};

	addFieldsToAccumulator(new applicantApplicationFigures(mortgage, 1).fields, '1');
	if (viewingVerified) {
		addFieldsToAccumulator(new applicantVerifiedFigures(mortgage, 1).fields, '1');
	}
	if (mortgage.twoApplicants) {
		addFieldsToAccumulator(new applicantApplicationFigures(mortgage, 2).fields, '2');
		if (viewingVerified) {
			addFieldsToAccumulator(new applicantVerifiedFigures(mortgage, 2).fields, '2');
		}
	}

	addFieldsToAccumulator(new mortgageApplicationFigures(mortgage).fields);

	if (viewingVerified) {
		addVerifiedFundsToAccumulator(1);
		if (mortgage.twoApplicants) {
			addVerifiedFundsToAccumulator(2);
		}
	}
	const addTotals = (figures) => {
		let keys = Object.keys(figures)
		keys.forEach(key => {
			if (figures[key].hasOwnProperty('sum')) {
				figures[key].total = figures[key].sum
			}
			else {
				figures[key].total = figures[key].value
			}
		})
	}
	addTotals(accumulator)
	// add variable total

	let variable1 = accumulator.overtime1.total + accumulator.allowances1.total + accumulator.other1.total + accumulator.commission1.total + accumulator.year1Bonus1.total
	let variableTotal = variable1
	accumulator.variable1 = {
		value: variable1,
		total: variable1
	}
	if (mortgage.twoApplicants) {
		let variable2 = accumulator.overtime2.total + accumulator.allowances2.total + accumulator.other2.total + accumulator.commission2.total + accumulator.year1Bonus2.total
		variableTotal += variable2
		accumulator.variable2 = {
			value: variable2,
			total: variable2
		}
	}
	accumulator.variableTotal = {
		value: variableTotal,
		total: variableTotal
	}

	// add savings total
	let savingsTotal = accumulator.savings1.total || 0
	if (mortgage.twoApplicants) {
		savingsTotal += accumulator.savings2.total || 0
	}
	accumulator.savingsTotal = {
		value: savingsTotal,
		total: savingsTotal
	}

	// add accommodation costs total
	let accommodationCostsTotal = accumulator.accommodationCosts1.total || 0
	if (mortgage.twoApplicants) {
		accommodationCostsTotal += accumulator.accommodationCosts2.total || 0
	}
	accumulator.accommodationCostsTotal = {
		value: accommodationCostsTotal,
		total: accommodationCostsTotal
	}

	// add clearing loans total
	let clearingLoansTotal = accumulator.clearingLoans1.total || 0
	if (mortgage.twoApplicants) {
		clearingLoansTotal += accumulator.clearingLoans2.total || 0
	}
	accumulator.clearingLoansTotal = {
		value: clearingLoansTotal,
		total: clearingLoansTotal
	}

	// add other PRA total
	let otherPRATotal = accumulator.otherPRA1.total || 0
	if (mortgage.twoApplicants) {
		otherPRATotal += accumulator.otherPRA2.total || 0
	}
	accumulator.otherPRATotal = {
		value: otherPRATotal,
		total: otherPRATotal
	}

	// add basic total
	let basicTotal = accumulator.basic1.total || 0
	if (mortgage.twoApplicants) {
		basicTotal += accumulator.basic2.total || 0
	}
	accumulator.basicTotal = {
		value: basicTotal,
		total: basicTotal
	}

	// add funds total
	let fundsTotal = accumulator.funds1.total || 0
	if (mortgage.twoApplicants) {
		fundsTotal += accumulator.funds2.total || 0
	}
	accumulator.fundsTotal = {
		value: fundsTotal,
		total: fundsTotal
	}

	return accumulator;
}